import React from 'react';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';
interface DashboardCardProps {
  prospectsCount: number;
  onNavigate: () => void;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({ prospectsCount, onNavigate }) => {
  const { t } = useTranslation('common');

  return (
    <section className="mb-6">
      <div className="text-sm text-white mb-2 font-bold">{t('dashboard.title')}</div>
      <div className="bg-white rounded-3xl p-6 flex flex-col items-center gap-4">
        <Home className="w-10 h-10 text-secondary mb-2" />
        <Link
          to="/prospects"
          onClick={() => onNavigate()}
          className="flex items-center justify-between text-secondary py-2 relative"
        >
          <span className="flex items-center gap-2 text-xl font-bold">
            {t('dashboard.prospects')}
          </span>
          {prospectsCount > 0 && (
            <span className="absolute -top-2 -right-6 bg-primary text-white text-sm rounded-full w-6 h-6 flex items-center justify-center">
              {prospectsCount}
            </span>
          )}
        </Link>
        <Link
          to="/alliances"
          onClick={() => onNavigate()}
          className="font-bold text-xl text-secondary py-2 text-center"
        >
          {t('dashboard.alliances')}
        </Link>
        <Link
          to="/jobs"
          onClick={() => onNavigate()}
          className="font-bold text-xl text-secondary py-2 text-center"
        >
          {t('dashboard.jobs')}
        </Link>
        <Link
          to="/quotes"
          onClick={() => onNavigate()}
          className="font-bold text-xl text-secondary py-2 text-center"
        >
          {t('dashboard.quotes')}
        </Link>
        <Link
          to="/projects"
          onClick={() => onNavigate()}
          className="font-bold text-xl text-secondary py-2 text-center"
        >
          {t('dashboard.projectManager')}
        </Link>
      </div>
    </section>
  );
};
